// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_N0j","cls2":"AuthorHeader-cls2_apl AuthorHeader-cls1_N0j"};